<div
  [formGroup]="form"
  [attr.data-test-id]="'wrap-' + fieldAttribute.id"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [attr.for]="fieldAttribute.id"
    [attr.id]="fieldAttribute.id"
    class="text-danger form-label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
  >
    {{ fieldAttribute.backendAttribute.label | translate: { email: lable } }}
  </label>
</div>
